<template>
    <div class="my-2">
        <dt class="" role="heading" aria-level="3">
            <button class="flex items-center justify-between w-full px-4 py-2 text-left bg-blue-200 font-bold focus:outline-none" @click="select">
                <slot name="heading"></slot>
            </button>
        </dt>

        <dd
                role="region"
                aria-labelledby="index"
                class="overflow-hidden transition-linear"
                :style="{height: height}"
        >
            <div ref="content" class="p-4 pb-6 richtext">
                <slot></slot>
            </div>
        </dd>
    </div>
</template>

<script>
export default {
    props: {
        active: {
            type: Boolean,
            default: false
        }
    },

    data: function () {
        return {
            isActive: this.active,
            height: '0px',
            loading: true
        };
    },

    watch: {
        isActive: function () {
            this.setHeight();

            this.loading = false;
        }
    },

    mounted: function () {
        this.setHeight();
    },

    methods: {
        select: function() {
            this.isActive = ! this.isActive;

            this.setHeight();
        },

        setHeight: function () {
            let contentHeight = getComputedStyle(this.$refs.content).height;

            this.height = this.isActive ? contentHeight : '0px';
        }
    }
};
</script>